import { MeteringObservedState } from '../types/metering-observed-state.type';

/**
 * Deterministic JSON for hashing: sorted keys, sorted featureFlags, no
 * insignificant whitespace. Reorder of equal state must not change the hash.
 */
export function canonicalizeMeteringObservedState(
  state: MeteringObservedState,
): string {
  const normalized: MeteringObservedState = {
    accessGrant: state.accessGrant,
    featureFlags: [...state.featureFlags].sort((a, b) =>
      a < b ? -1 : a > b ? 1 : 0,
    ),
    systemContractId: state.systemContractId,
    tenantStatus: state.tenantStatus,
  };

  return JSON.stringify(normalized);
}
